var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetamaskFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 106 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4377_14701)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1914 81.8557L46.43 84.5722V81.0199L47.2658 80.1841H53.1164V84.363V87.2883H46.8479L39.1167 83.9451L36.1914 81.8557Z",
    fill: "#CDBDB2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.623 81.8557L59.5936 84.5722V81.0199L58.7578 80.1841H52.9072V84.363V87.2883H59.1757L66.9065 83.9451L69.623 81.8557Z",
    fill: "#CDBDB2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.2655 74.125L46.4297 81.0201L47.4742 80.1843H58.3395L59.5932 81.0201L58.7574 74.125L57.0858 73.0801L48.7279 73.2892L47.2655 74.125Z",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.623 27.5293L46.6378 39.2304L48.9364 73.289H57.0851L59.5925 39.2304L64.1894 27.5293H41.623Z",
    fill: "#F89C35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6845 53.2303L13.834 70.1549L28.4603 69.3191H37.8628V62.0061L37.4449 46.9619L35.3554 48.6335L19.6845 53.2303Z",
    fill: "#F89D35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7578 55.1104L47.8915 55.5282L46.0112 64.304L37.862 62.2146L30.7578 55.1104Z",
    fill: "#D87C30"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7578 55.3198L37.862 62.0061V68.6925L30.7578 55.3198Z",
    fill: "#EA8D3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8633 62.2148L46.2212 64.3043L48.9377 73.2892L47.057 74.3338L37.8633 68.9012V62.2148Z",
    fill: "#F89D35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.863 68.9014L36.1914 81.8561L47.2658 74.1252L37.863 68.9014Z",
    fill: "#EB8F35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.8922 55.5283L48.9371 73.289L45.8027 64.1997L47.8922 55.5283Z",
    fill: "#EA8E3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.252 69.1105L37.8635 68.9014L36.192 81.8561L28.252 69.1105Z",
    fill: "#D87C30"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4308 87.4977L36.1912 81.856L28.2512 69.1104L13.834 70.1549L18.4308 87.4977Z",
    fill: "#EB8F35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.6378 39.2305L37.6533 46.7526L30.7578 55.1105L47.8915 55.7375L46.6378 39.2305Z",
    fill: "#E8821E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1914 81.8559L47.2658 74.125L46.43 80.8113V84.5724L38.9079 83.1096L36.1914 81.8559Z",
    fill: "#DFCEC3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.623 81.8559L58.7578 74.125L59.5936 80.8113V84.5724L67.1157 83.1096L69.623 81.8559Z",
    fill: "#DFCEC3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2951 59.2896L45.5938 64.0955L37.4446 62.0061L43.2951 59.2896Z",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2227 17.709L46.6395 39.2304L41.8339 27.5293L18.2227 17.709Z",
    fill: "#E88F35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.222 17.709L14.4609 29.2011L16.5504 41.738L15.0878 42.5737L17.1773 44.4543L15.5057 45.9169L17.8041 48.0064L16.3415 49.2601L19.6846 53.439L35.3557 48.6332C43.0171 42.5041 46.7782 39.3699 46.6389 39.2306C46.4996 39.0913 37.0273 31.9174 18.222 17.709Z",
    fill: "#8E5A30"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.1299 53.2303L91.9805 70.1549L77.3541 69.3191H67.9517V62.0061L68.3696 46.9619L70.4591 48.6335L86.1299 53.2303Z",
    fill: "#F89D35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.0566 55.1104L57.923 55.5282L59.8033 64.304L67.9524 62.2146L75.0566 55.1104Z",
    fill: "#D87C30"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.0566 55.3198L67.9525 62.0061V68.6925L75.0566 55.3198Z",
    fill: "#EA8D3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.9512 62.2148L59.5933 64.3043L56.8768 73.2892L58.7575 74.3338L67.9512 68.9012V62.2148Z",
    fill: "#F89D35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.9515 68.9014L69.623 81.8561L58.7578 74.334L67.9515 68.9014Z",
    fill: "#EB8F35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.9222 55.5283L56.8773 73.289L60.0117 64.1997L57.9222 55.5283Z",
    fill: "#EA8E3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.5625 69.1105L67.9509 68.9014L69.6225 81.8561L77.5625 69.1105Z",
    fill: "#D87C30"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.3836 87.4977L69.6233 81.856L77.5633 69.1104L91.9805 70.1549L87.3836 87.4977Z",
    fill: "#EB8F35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.1767 39.2305L68.1612 46.7526L75.0566 55.1105L57.923 55.7375L59.1767 39.2305Z",
    fill: "#E8821E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.5193 59.2896L60.2207 64.0955L68.3698 62.0061L62.5193 59.2896Z",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.5938 17.709L59.1768 39.2304L63.9825 27.5293L87.5938 17.709Z",
    fill: "#E88F35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.5925 17.709L91.3535 29.2011L89.264 41.738L90.7267 42.5737L88.6372 44.4543L90.3088 45.9169L88.0104 48.0064L89.473 49.2601L86.1298 53.439L70.4588 48.6332C62.7974 42.5041 59.0363 39.3699 59.1756 39.2306C59.3149 39.0913 68.7872 31.9174 87.5925 17.709Z",
    fill: "#8E5A30"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4377_14701"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78.75,
    height: 70.2064,
    fill: "white",
    transform: "translate(13.625 17.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamaskFace);
export default __webpack_public_path__ + "static/media/metamask-face.a8f2d58b590ab1d18777f9f4799e6a36.svg";
export { ForwardRef as ReactComponent };